var _path, _path2, _path3, _path4, _path5, _line, _line2, _line3, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSurveyCompany(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 96,
    viewBox: "0 0 120 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9998 3V93H71.9998V18.2542L43.9998 3Z",
    fill: "#E4E1FF",
    stroke: "#1B1B1B",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72 93.0005V53.0005L90 62.2091V93.0005H72Z",
    fill: "#FFBB00",
    stroke: "#1B1B1B",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0002 46.7384L72.0002 34.1216V93.0001H31.0009L31.0002 46.7384Z",
    stroke: "#1B1B1B",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0002 46.7384L72.0002 34.1216V93.0001H31.0009L31.0002 46.7384Z",
    fill: "#8372FF",
    stroke: "#1B1B1B",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2277 35.1362L63.9204 37.372L63.8127 92.3218L71.1882 92.2268L71.2277 35.1362Z",
    fill: "#E4E1FF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 63.75,
    y1: 13.9348,
    x2: 63.75,
    y2: 93.0002,
    stroke: "#1B1B1B",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 39.75,
    y1: 44.2148,
    x2: 39.75,
    y2: 92.9999,
    stroke: "#1B1B1B",
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 43.7631,
    y1: 35.9329,
    x2: 72.7631,
    y2: 26.2883,
    stroke: "#1B1B1B",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 81.0002,
    cy: 70.0005,
    r: 5,
    fill: "white",
    stroke: "#1B1B1B",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyCompany);
export default __webpack_public_path__ + "static/media/survey-company.3d54afe8.svg";
export { ForwardRef as ReactComponent };